export function AnnouncementSectionTitle({ title }: { title: string }) {
  return (
    <h3 className='text-sm! font-normal! capitalize text-gray-600'>{title}</h3>
  );
}
